import { reduceLoop54Product } from '~/services/loop54/utils';
import useComplementaryEntities from '../useComplementaryEntities';

export default function useComplementaryResults(productId: string) {
    return useComplementaryEntities(
        {
            entity: {
                type: 'Product',
                id: productId,
            },
            resultsOptions: {
                sortBy: [{ type: 'relevance' }],
                take: 10,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
